<template>
    <nav
        class="z-page-nav js-top-text is-animate js-z-page-nav"
        :class="[
            classForOpenedWrapper,
            { 'z-page-nav--single' : dataItems.length === 0 }
        ]"
        ref="container"
    >
        <span ref="section" v-html="section" @click.prevent="toggleWrapper()"></span>
        <ul class="z-page-nav__list ul--clear" ref="list">
            <li
                v-for="(item, i) in dataItems"
                :key="i"
                class="z-page-nav__item"
            >
                <a :href="item.href" class="link z-page-nav__link" v-html="item.title"></a>
            </li>
            <li class="z-page-nav__item col-mobile-hide" v-if="extraItems.length > 0">
                <a
                    href="#"
                    class="link z-page-nav__link z-page-nav__popup-btn js-z-page-nav-popup__btn js-z-page-nav-popup__item"
                    :class="classForOpened"
                    @click.prevent="toggleContainer()"
                >Еще</a>
            </li>
            <li class="z-page-nav__further col-default-hide" v-if="extraItems.length > 0">
                <a
                    v-for="(item, i) in extraItems"
                    :key="i"
                    :href="item.href"
                    v-html="item.title"
                ></a>
            </li>
        </ul>
        <div
            class="z-page-nav__popup js-z-page-nav-popup__container js-z-page-nav-popup__item col-mobile-hide"
            :class="classForOpened"
            v-if="extraItems.length > 0"
        >
            <a
                v-for="(item, i) in extraItems"
                :key="i"
                :href="item.href"
                v-html="item.title"
            ></a>
        </div>
    </nav>
</template>

<script>
import { throttle } from 'throttle-debounce'

export default {
    name: 'page-nav',
    props: {
        section: {
            type: String
        },
        animate: {
            type: Boolean,
            default: true
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isAnimate: false,
            dataItems: this.items,
            extraItems: [],
            device: 'desktop',
            classForOpened: '',
            classForOpenedWrapper: ''
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.animate) {
                this.initAnimate();
            }
            if (window.innerWidth > 1080) {
                const widthContainer = this.$refs.container.offsetWidth - this.$refs.section.offsetWidth
                if (this.$refs.list && this.$refs.list.offsetWidth > 0 && widthContainer > 0) {
                    this.calcItems()
                }
            }

            $(document).on('click', function (e) {
                if (!$(e.target).hasClass('js-z-page-nav-popup__item')) {
                    this.classForOpened = ''
                }
            });
        })
        window.addEventListener('resize', throttle(500, e => {
            if (window.innerWidth > 1080) {
                const widthContainer = this.$refs.container.offsetWidth - this.$refs.section.offsetWidth
                if (this.$refs.list && this.$refs.list.offsetWidth > 0 && widthContainer > 0) {
                    this.calcItems()
                }
            }
        }))
    },
    computed: {
        styleObject: function () {
            const styles = {}

            return styles
        },
        classObject () {
            let arrClass = []
            // let arrClass = [
            //     {
            //         'page-banner--js-animate' : this.animate,
            //         'page-banner--without-overlay' : !this.overlay,
            //         'page-banner--is-animate' : this.isAnimate,
            //         'page-banner--small' : this.small,
            //         'page-banner--main' : this.main,
            //     }
            // ]

            // if (this.theme) {
            //     arrClass.push(`page-banner--theme-${this.theme}`)
            // }

            return arrClass
        }
    },
    methods: {
        closeWrapper () {
            if (window.innerWidth <= 1080) {
                this.classForOpenedWrapper = ''
            }
        },
        toggleWrapper () {
            if (window.innerWidth <= 1080 && this.dataItems.length > 0) {
                if (this.classForOpenedWrapper.length) {
                    this.classForOpenedWrapper = ''
                } else {
                    this.classForOpenedWrapper = 'is-open'
                }
            }
        },
        toggleContainer () {
            if (this.classForOpened.length) {
                this.classForOpened = ''
            } else {
                this.classForOpened = 'opened'
            }
        },
        calcItems () {
            let widthContainer = this.$refs.container.offsetWidth - this.$refs.section.offsetWidth

            if (this.$refs.list.offsetWidth > widthContainer) {
                this.extraItems.push(this.dataItems[this.dataItems.length - 1])
                this.dataItems.splice(this.dataItems.length - 1, 1)

                this.$nextTick(() => {
                    this.calcItems()
                })
            }
        },
        initAnimate () {
            // const $banner = $(this.$refs.banner);
            // const _this = this;
            // $banner.imagesLoaded({}, function () {
            //     setTimeout(function () {
            //         _this.isAnimate = true
            //     }, 200);
            // });
        }
    }
};
</script>



// WEBPACK FOOTER //
// frontend/components/page-nav/page-nav.vue